/** biome-ignore-all lint/style/useNamingConvention: <envs> */
import { z } from 'zod';
import { checkResourceAccess } from '@/app_lib/services/tinypass/actions';
import { createSession } from '@/app_lib/session';
import type { UserSessionToken } from '@/app_lib/types/auth';

interface TpLoginProps {
  onLogin?: () => void;
  onLogout?: () => void;
  onLoginDisplayed?: () => void;
}

export const pianoEnvSchema = z.object({
  APPLE_MERCHANT_ID: z.string().optional(),
  PIANO_AID: z.string(),
  PIANO_API_BASE_URL: z.string().optional(),
  PIANO_CDN_URL: z.string(),
  PIANO_COMPOSER_HOST: z.string().optional(),
  PIANO_ENDPOINT: z.string().optional(),
  PIANO_ID_URL: z.string().optional(),
  PIANO_RID_DIGITAL: z.string(),
  PIANO_SANDBOX: z.boolean(),
  PIANO_SITE_ID: z.string(),
  PIANO_STATIC_DOMAIN: z.string().optional(),
});

export const {
  PIANO_API_BASE_URL,
  PIANO_CDN_URL,
  PIANO_AID,
  PIANO_RID_DIGITAL,
  PIANO_SITE_ID,
  PIANO_COMPOSER_HOST,
  PIANO_ENDPOINT,
  PIANO_ID_URL,
  PIANO_SANDBOX,
  PIANO_STATIC_DOMAIN,
  APPLE_MERCHANT_ID,
} = pianoEnvSchema.parse({
  APPLE_MERCHANT_ID: process.env.APPLE_MERCHANT_ID,
  PIANO_AID: process.env.PIANO_AID,
  PIANO_API_BASE_URL: process.env.PIANO_API_BASE_URL,
  PIANO_CDN_URL: process.env.PIANO_CDN_URL,
  PIANO_COMPOSER_HOST: process.env.PIANO_COMPOSER_HOST,
  PIANO_ENDPOINT: process.env.PIANO_ENDPOINT,
  PIANO_ID_URL: process.env.PIANO_ID_URL,
  PIANO_RID_DIGITAL: process.env.PIANO_RID_DIGITAL,
  PIANO_SANDBOX: process.env.PIANO_SANDBOX,
  PIANO_SITE_ID: process.env.PIANO_SITE_ID,
  PIANO_STATIC_DOMAIN: process.env.PIANO_STATIC_DOMAIN,
});

export const login = ({ onLogin }: TpLoginProps) => {
  if (!window?.tp?.pianoId) {
    // console.error('Cannot display login modal, piano is not initialized');
    return false;
  }
  window.tp.pianoId.show({
    disableSignUp: false,
    displayMode: 'modal',
    loggedIn: async (data) => {
      // console.info('User: ', data.user, 'login: ', data.token);
      try {
        const accessResponse = await checkResourceAccess(data.user.uid);
        const newSessionToken: UserSessionToken = {
          hasAccess: accessResponse?.access.granted ?? false,
          userId: data.user.uid,
        };
        await createSession(newSessionToken);
        if (onLogin) {
          onLogin();
        }
      } catch (e) {
        // console.error('Error creating auth token', e);
        // ToDo: Implement more robust error handling here
        return;
      }
    },
    loggedOut: () => {
      // console.info('User logged out.');
    },
    loginDisplayed: () => {
      // console.info('Login displayed.');
    },
    screen: 'login',
  });
};

export function logOut() {
  window.tp.pianoId.logout();
}
